import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SButton } from "../../components";
import Icon from "../../icons";
const PropertyLabel = ({ hasValue, onClick, label, icon = /*#__PURE__*/ _jsx(Icon, {
    name: "MdRefresh",
    size: "sm"
}) })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "min-w-[85px] group",
        children: /*#__PURE__*/ _jsxs(SButton, {
            className: `!justify-end !-ml-1 ${hasValue ? "!tracking-wide" : "!font-normal !tracking-wide"}`,
            variant: hasValue ? "primary" : "secondary",
            isMinimal: !hasValue,
            disabled: !hasValue,
            size: "sm",
            onClick: onClick,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "",
                    children: label
                }),
                hasValue && /*#__PURE__*/ _jsx("span", {
                    className: "hidden group-hover:block",
                    children: icon
                })
            ]
        })
    });
};
export default PropertyLabel;
